import { defineStore } from "pinia"
import { fetchWrapper, BASE_URL, trimHora, formatFecha, createDate, ACTIVO, canCancel, horarioMenor } from "@/helpers"

// const baseUrl = `${import.meta.env.VITE_API_URL}/users`

export const usePasesStore = defineStore("pasesStore", {
  state: () => {
    return {
      pases: [],
      cancel_limit: 0,
      inscription_limit: 0,
      idPaseSelected: null,
      idActividadClaseSelected: null,
    }
  },
  getters: {
    // computed prop of state
    pasesFormateados(state) {
      const pasesMapped = state.pases.map((p) => {
        const { usos, can_cancel } = this.calculate_usos(p.idcontratopasesdetalles)
        return {
          id: p.idcontratopasesdetalles,
          idactividad: p.idactividad,
          actividad: p.descripcion,
          disponibles: parseInt(p.cantidad) - usos,
          cancancel: can_cancel,
          total: p.cantidad,
        }
      })

      const pasesWithoutRep = [...new Map(pasesMapped.map((v) => [v.id, v])).values()]
      const pasesGrouped = []
      pasesWithoutRep.forEach((p) => {
        if (p.disponibles > 0 || p.cancancel) {
          const indexFound = pasesGrouped.findIndex((pwr) => pwr.idactividad === p.idactividad)
          let newPase = p
          if (indexFound >= 0) {
            newPase = {
              id: p.id < pasesGrouped[indexFound].id ? p.id : pasesGrouped[indexFound].id,
              idactividad: p.idactividad,
              actividad: p.actividad,
              disponibles: p.disponibles + pasesGrouped[indexFound].disponibles,
              total: parseInt(p.total) + parseInt(pasesGrouped[indexFound].total),
            }
            pasesGrouped[indexFound] = newPase
          } else {
            pasesGrouped.push(newPase)
          }
        }
      })
      return pasesGrouped
    },
    pasesReservados: (state) => {
      return state.pases
        .filter((e) => e.pcactivo == ACTIVO && !horarioMenor(createDate(e.fecha), trimHora(e.horario)))
        .map((p) => {
          return {
            id: p.idpaseclase,
            actividad: p.descripcionclase,
            sede: p.sede,
            fecha: createDate(p.fecha),
            fechaUX: formatFecha(p.fecha),
            hora: trimHora(p.horario),
            estado: 1,
            canCancel: canCancel(createDate(p.fecha), p.horario, state.cancel_limit),
            idPase: p.idactividad, // TODO: sep, nombres medio incongrugentes lpm
            idActividadClase: p.idactividadclase,
          }
        })
        .sort((a, b) => a.fecha > b.fecha)
    },
    pasesUtilizados: (state) => {
      return state.pases
        .filter((e) => e.pcactivo == ACTIVO && horarioMenor(createDate(e.fecha), trimHora(e.horario)))
        .map((p) => {
          return {
            id: p.idpaseclase,
            actividad: p.descripcionclase,
            fecha: createDate(p.fecha),
            fechaUX: formatFecha(p.fecha),
            hora: trimHora(p.horario),
            estado: 1,
            canCancel: canCancel(createDate(p.fecha), p.horario, state.cancel_limit),
            idPase: p.idactividad, // TODO: sep, nombres medio incongrugentes lpm
            idActividadClase: p.idactividadclase,
          }
        })
        .sort((a, b) => a.fecha > b.fecha)
    },
    arrayIdActividadesPases() {
      return this.pasesFormateados.map((p) => {
        return p.idactividad
      })
    },
    paseSelected(state) {
      return { idPaseSelected: state.idPaseSelected, idActividadClaseSelected: state.idActividadClaseSelected }
    },
  },
  actions: {
    async getUserPases() {
      const response = await fetchWrapper.get(`${BASE_URL}/pases_persona`)
      this.cancel_limit = response.cancel_limit
      this.inscription_limit = response.inscription_limit
      this.pases = response.pases
    },
    async cancelPase(id_pase_clase) {
      const body = { id_pase_clase: id_pase_clase }
      const anulacion = await fetchWrapper.post(`${BASE_URL}/cancel_pase_clase`, body)
      await this.getUserPases()
      return anulacion
    },
    calculate_usos(id_contrato_pases_detalles) {
      /*
      return this.pases.filter((pase) => {
        return pase.idcontratopasesdetalles == id_contrato_pases_detalles && pase.idclase && pase.pcactivo == ACTIVO
      }).length */
      let can_cancel = false
      const pases_usados = []
      this.pases.forEach((pase) => {
        if (pase.idcontratopasesdetalles == id_contrato_pases_detalles && pase.idclase && pase.pcactivo == ACTIVO) {
          pases_usados.push(pase)
          const cc = canCancel(createDate(pase.fecha), pase.horario, this.cancel_limit)
          if (cc) {
            can_cancel = true
          }
        }
      })
      return { usos: pases_usados.length, can_cancel }
    },
    setPaseSelected(idPase, idActividadClase) {
      this.idPaseSelected = idPase
      this.idActividadClaseSelected = idActividadClase
    },
    cleanPaseSelected() {
      this.idPaseSelected = null
      this.idActividadClaseSelected = null
    },
  },
})
